<template>
  <v-dialog
    :value="value"
    :persistent="true"
    max-width="50rem">
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <v-container grid-list-md>
            <v-layout>
              <v-flex>
                <v-autocomplete
                  v-model="selectedRate"
                  :disabled="loading"
                  :items="rates"
                  :loading="loading"
                  :rules="rateRules"
                  label="Source rate"
                  item-text="name"
                  item-value="id"
                  return-object>
                  <template
                    slot="item"
                    slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ data.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ data.item.description }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action-text>
                      <span>${{ data.item.value }}</span>
                    </v-list-tile-action-text>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  :value="adjustedValue"
                  :rules="realCostRules"
                  label="Real cost"
                  @change="val => editedValue = val"/>
              </v-flex>
              <v-flex>
                <v-text-field
                  :value="adjustedUnit"
                  :rules="[v => !!v || 'Unit is required']"
                  label="Unit"
                  @change="val => editedUnit = val"/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="editedPO"
                  :rules="poRules"
                  label="Purchase order reference"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="posting"
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          :disabled="posting || !valid"
          flat
          @click="save">
          <v-progress-circular
            v-if="posting"
            indeterminate/>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "new-cost-dialog",
  props: {
    jobId: {
      required: true,
      type: Number
    },
    subId: {
      required: true,
      type: Number
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      editedPO: "PO-",
      editedUnit: null,
      editedValue: null,
      loading: false,
      poRules: [
        (v) => v.substring(0, 3) === "PO-" || "Must start with 'PO-'",
        (v) => v.length > 3 || "Must specify an ID"
      ],
      posting: false,
      rates: [],
      rateRules: [(v) => typeof v.name === "string" || "Rate is required"],
      realCostRules: [
        (v) => !!v || "Real cost is required",
        (v) => !isNaN(parseFloat(v)) || "Must be a number",
        (v) => typeof v === "string" && !isNaN(parseFloat(v)) &&
        parseFloat(v).toFixed(2).length >= v.length || "Precision too high"
      ],
      selectedRate: {},
      valid: false
    };
  },
  computed: {
    adjustedUnit () {
      if (this.editedUnit) {
        return this.editedUnit;
      }
      if (this.selectedRate.unit) {
        return this.selectedRate.unit;
      }
    },
    adjustedValue () {
      if (this.editedValue) {
        return this.editedValue;
      }
      if (this.selectedRate.value) {
        return this.selectedRate.value;
      }
    }
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/rates?sub=${this.subId}`).
      then((r) => {
        this.loading = false;
        this.rates = Array.from(r.data);
      }).
      catch(() => this.loading = false);
  },
  methods: {
    save () {
      this.posting = true;
      this.$http.
        post("/api/job_costs", {
          jobId: this.jobId,
          class: this.selectedRate.class,
          description: this.selectedRate.description,
          name: this.selectedRate.name,
          purchaseOrder: this.editedPO,
          unit: this.adjustedUnit,
          value: this.adjustedValue
        }).
        then(() => {
          this.$emit("refresh");
          this.$emit("input", false);
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Job/Costs/NewCostDialog.vue